import React, { FunctionComponent, useState } from "react";

import { Icon, Text, TextColor, WhiteSpace } from "@multiweb/reactComponents";
import { bridge } from "@multiweb/reactCore/bridge";
import { bemClassNames } from "@multiweb/reactUtils";
import { IconCode } from "@multiweb/types/contracts";

const classNames = bemClassNames("property-row-component");
const valueContainer = classNames("value-container");
const iconSection = classNames("icon-section");
const { valueToEnumValue } = bridge;

export type PropertyRowComponentProps = {
    readonly description: string;
    readonly value: string;
    readonly iconName?: string;
    readonly isItemSelected?: boolean;
    readonly isSelectable?: boolean;
    readonly onClick?: () => void;
    readonly onDoubleClick?: () => void;
};

export const PropertyRowComponent: FunctionComponent<PropertyRowComponentProps> = ({ description, value, iconName, isItemSelected, isSelectable = false, onClick, onDoubleClick }) => {
    const [isMouseOver, setIsMouseOver] = useState(false);
    const iconCode: IconCode | undefined = valueToEnumValue(IconCode, iconName ?? "");

    const onMouseOver = () => {
        if (isSelectable && !isMouseOver)
            setIsMouseOver(true);
    };

    const onMouseLeave = () => {
        if (isSelectable && isMouseOver)
            setIsMouseOver(false);
    };

    return (
        <div
            className={classNames({
                "is-mouse-over": isSelectable && isMouseOver,
                "selected": isSelectable && isItemSelected,
                "clickable": !!onClick,
            })}
            {...{ onMouseOver, onMouseLeave, onClick, onDoubleClick }}
        >
            <Text value={description} title={description} color={TextColor.textSecondary} isTextSelectable={!onClick} ellipsis whiteSpace={WhiteSpace.nowrap} />
            <div className={valueContainer}>
                {iconCode && <div className={iconSection}><Icon iconCode={iconCode}></Icon></div>}
                <Text value={value} title={value} ellipsis isTextSelectable={!onClick} whiteSpace={WhiteSpace.nowrap} />
            </div>
        </div>
    );
};
